import React, { memo, useMemo } from 'react'
import { Switch, withRouter } from 'react-router-dom'
import { createRoutes } from './createRoutes'

export const SignalRouter = memo(function SignalRouter({
  activeAccount,
  config,
  location
}) {
  const { routeDefinitions, routeKeyGenerator } = config
  const routeKey = routeKeyGenerator(location)

  const routes = useMemo(() => {
    const childProps = {
      activeAccount
    }
    return createRoutes(routeDefinitions, childProps)
  }, [routeDefinitions, activeAccount])

  return (
    <Switch location={location} key={routeKey}>
      {routes}
    </Switch>
  )
})

export default withRouter(SignalRouter)
